import "@inter-ikea-kompis/component-summary-page/lib/components/summary-page-controller/SummaryPageController.js";
import WrappedComponent from "@inter-ikea-kompis/component-summary-page/lib/components/summary-page-controller/SummaryPageController.js";
import * as React from 'react';
import * as PropTypes from 'prop-types';
import KompisElementRegistry from '@inter-ikea-kompis/web-component/lib/registry/KompisElementRegistry.js';
class KompisSummaryPageController extends React.Component {
    constructor() {
        super(...arguments);
        this.customElements = new KompisElementRegistry();
        this.listeners = {};
        this.ref = {
            current: null
        };
    }
    render() {
        return React.createElement(this.customElements.getInternalName("kompis-summary-page-controller"), this.getForwardedProps(), this.props.children);
    }
    componentWillUnmount() {
        this.setState({
            element: null
        });
        this.removeAllListeners(this.ref.current);
        this.ref.current = null;
    }
    UNSAFE_componentWillMount() {
        this.customElements.define("kompis-summary-page-controller", WrappedComponent);
    }
    focus() {
        this.ref.current.focus();
    }
    removeAllListeners(element) {
        for (const eventType in this.listeners) {
            const callback = this.listeners[eventType];
            if (typeof callback === 'function') {
                element.removeEventListener(eventType, callback);
            }
            delete this.listeners[eventType];
        }
    }
    updateEventListener(element, callback, eventType) {
        if (callback !== this.listeners[eventType]) {
            if (typeof callback === 'function') {
                element.removeEventListener(eventType, this.listeners[eventType]);
            }
            this.listeners[eventType] = callback;
            if (typeof callback === 'function') {
                element.addEventListener(eventType, this.listeners[eventType]);
            }
        }
    }
    getForwardedProps() {
        const forwardedProps = {
            ref: this.onRef.bind(this),
            class: this.props.className,
            'data-element-name': "kompis-summary-page-controller"
        };
        for (const key in this.props) {
            if (!(key in this['constructor']['propTypes'])) {
                forwardedProps[key] = this.props[key];
            }
        }
        return forwardedProps;
    }
    onRef(element) {
        if (element === null) {
            return;
        }
        if (element !== this.ref.current && this.ref.current !== null) {
            this.removeAllListeners(this.ref.current);
        }
        this.updateAllEventListeners(element, this.props);
        this.updateAllPropValues(element, this.props);
        this.ref.current = element;
    }
    updateAllPropValues(element, props) {
        element.analytics = props.analytics;
        element.assistanceCardApplicationName = props.assistanceCardApplicationName;
        element.buyInStoreLink = props.buyInStoreLink;
        element.collectableProducts = props.collectableProducts;
        element.configurationMeasures = props.configurationMeasures;
        element.contentToPrint = props.contentToPrint;
        element.customTabButtons = props.customTabButtons;
        element.defaultSortBy = props.defaultSortBy;
        element.designConfiguration = props.designConfiguration;
        element.designLink = props.designLink;
        element.designSaved = props.designSaved;
        element.enableMainMargins = props.enableMainMargins;
        element.enableMargins = props.enableMargins;
        element.experimental = props.experimental;
        element.images = props.images;
        element.kiosk = props.kiosk;
        element.linkCard = props.linkCard;
        element.loginBehaviour = props.loginBehaviour;
        element.measurementSystem = props.measurementSystem;
        element.measurements = props.measurements;
        element.messageSection = props.messageSection;
        element.printHoistTarget = props.printHoistTarget;
        element.productDescription = props.productDescription;
        element.productListRemovable = props.productListRemovable;
        element.productListSections = props.productListSections;
        element.productMeasures = props.productMeasures;
        element.productName = props.productName;
        element.screenshotAlt = props.screenshotAlt;
        element.screenshotUrl = props.screenshotUrl;
        element.securityInformation = props.securityInformation;
        element.serviceOptions = props.serviceOptions;
        element.shoppingItems = props.shoppingItems;
        element.showAssemblyServices = props.showAssemblyServices;
        element.showAssistanceCard = props.showAssistanceCard;
        element.showDesignText = props.showDesignText;
        element.showEditDesignButton = props.showEditDesignButton;
        element.showKioskMainCTAButton = props.showKioskMainCTAButton;
        element.showPrintButton = props.showPrintButton;
        element.showSaveDesign = props.showSaveDesign;
        element.showTotalPackageWeight = props.showTotalPackageWeight;
        element.startHeadingsAtH2 = props.startHeadingsAtH2;
        element.state = props.state;
        element.theme = props.theme;
        element.vpcCode = props.vpcCode;
    }
    updateAllEventListeners(element, props) {
        this.updateEventListener(element, props.onDesignSavedToProfile, "designSavedToProfile");
        this.updateEventListener(element, props.onEditDesignButtonClick, "editDesignButtonClick");
        this.updateEventListener(element, props.onKioskMainCtaButtonClick, "kioskMainCtaButtonClick");
        this.updateEventListener(element, props.onLinkCardClick, "linkCardClick");
        this.updateEventListener(element, props.onLogInAndSaveDesign, "logInAndSaveDesign");
        this.updateEventListener(element, props.onPrintButtonClick, "printButtonClick");
        this.updateEventListener(element, props.onPrintQrCodeRendered, "printQrCodeRendered");
        this.updateEventListener(element, props.onProductListRemove, "productListRemove");
        this.updateEventListener(element, props.onStateChange, "stateChange");
        this.updateEventListener(element, props.onTabChange, "tabChange");
        this.updateEventListener(element, props.onTrackAnalytics, "trackAnalytics");
    }
}
KompisSummaryPageController.propTypes = {
    className: PropTypes.string,
    children: PropTypes.any,
    analytics: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    assistanceCardApplicationName: PropTypes.string,
    buyInStoreLink: PropTypes.string,
    collectableProducts: PropTypes.bool,
    configurationMeasures: PropTypes.string,
    contentToPrint: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    customTabButtons: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    defaultSortBy: PropTypes.string,
    designConfiguration: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    designLink: PropTypes.string,
    designSaved: PropTypes.bool,
    enableMainMargins: PropTypes.bool,
    enableMargins: PropTypes.bool,
    experimental: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    images: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    kiosk: PropTypes.bool,
    linkCard: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    loginBehaviour: PropTypes.string,
    measurementSystem: PropTypes.string,
    measurements: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    messageSection: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    printHoistTarget: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    productDescription: PropTypes.string,
    productListRemovable: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    productListSections: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    productMeasures: PropTypes.string,
    productName: PropTypes.string,
    screenshotAlt: PropTypes.string,
    screenshotUrl: PropTypes.string,
    securityInformation: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    serviceOptions: PropTypes.oneOfType([PropTypes.array, PropTypes.object]).isRequired,
    shoppingItems: PropTypes.oneOfType([PropTypes.array, PropTypes.object]).isRequired,
    showAssemblyServices: PropTypes.bool,
    showAssistanceCard: PropTypes.bool,
    showDesignText: PropTypes.bool,
    showEditDesignButton: PropTypes.bool,
    showKioskMainCTAButton: PropTypes.bool,
    showPrintButton: PropTypes.bool,
    showSaveDesign: PropTypes.bool,
    showTotalPackageWeight: PropTypes.bool,
    startHeadingsAtH2: PropTypes.bool,
    state: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    theme: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    vpcCode: PropTypes.string,
    onStateChange: PropTypes.func,
    onKioskMainCtaButtonClick: PropTypes.func,
    onProductListRemove: PropTypes.func,
    onLogInAndSaveDesign: PropTypes.func,
    onDesignSavedToProfile: PropTypes.func,
    onLinkCardClick: PropTypes.func,
    onTrackAnalytics: PropTypes.func,
    onPrintButtonClick: PropTypes.func,
    onEditDesignButtonClick: PropTypes.func,
    onTabChange: PropTypes.func,
    onPrintQrCodeRendered: PropTypes.func
};
export default KompisSummaryPageController;
